import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=61ffc874"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61ffc874')) {
      api.createRecord('61ffc874', component.options)
    } else {
      api.reload('61ffc874', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=61ffc874", function () {
      api.rerender('61ffc874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/footer/type_2/Footer.vue"
export default component.exports